module.exports = __webpack_public_path__ + "static/media/logo.5d5d9eef.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Layout/Header/logo.svg
 ** module id = 423
 ** module chunks = 0
 **/